import { useBidsData } from "./useBidsData";
import { useDateSelection } from "./useDateSelection";
import { REQUIRED_PRODUCTS } from "../constants";

const useRegelBidsData = () => {
  const { selectedDate, handleDateChange } = useDateSelection();
  const { bids, loading, error, customFormatDate } = useBidsData(selectedDate);

  return {
    bids,
    loading,
    error,
    selectedDate,
    requiredProducts: REQUIRED_PRODUCTS,
    customFormatDate,
    handleDateChange,
  };
};

export default useRegelBidsData;
